enum ActionTypes {
  REDUX_FORM_ARRAY_PUSH = "@@redux-form/ARRAY_PUSH",
  REDUX_FORM_ARRAY_REMOVE = "@@redux-form/ARRAY_REMOVE",
  REDUX_FORM_CHANGE = "@@redux-form/CHANGE",
  REDUX_FORM_INITIALIZE = "@@redux-form/INITIALIZE",
  REDUX_UNDO = "@@redux-undo/UNDO",

  APP_INIT = "APP_INIT",
  API_ERROR = "API_ERROR",
  RESET_STORE = "RESET_STORE",
  APP_SIMULATION_SET = "APP_SIMULATION_SET",
  APP_SIMULATION_BASELINE_SET = "APP_SIMULATION_BASELINE_SET",
  APP_SIMULATION_RESET = "APP_SIMULATION_RESET",

  SNACKBAR_MESSAGE_CREATE = "SNACKBAR_MESSAGE_CREATE",
  SNACKBAR_MESSAGE_REMOVE = "SNACKBAR_MESSAGE_REMOVE",

  NAVIGATE_NEW_ARTICLE_DIALOG = "NAVIGATE_NEW_ARTICLE_DIALOG",
  NAVIGATE_ARTICLE_LIST = "NAVIGATE_ARTICLE_LIST",
  NAVIGATE_EDIT_ARTICLE_DIALOG = "NAVIGATE_EDIT_ARTICLE_DIALOG",

  UI_ARTICLE_DIALOG_CHANGE_STANDARD_TECHNOLOGY = "UI_ARTICLE_DIALOG_CHANGE_STANDARD_TECHNOLOGY",
  UI_ARTICLE_DIALOG_CHANGE_STANDARD_TEMPLATE = "UI_ARTICLE_DIALOG_CHANGE_STANDARD_TEMPLATE",
  UI_ARTICLE_DIALOG_DELETED_TECHNOLOGY = "UI_ARTICLE_DIALOG_DELETED_TECHNOLOGY",
  UI_ARTICLE_DIALOG_DELETED_TEMPLATE = "UI_ARTICLE_DIALOG_DELETED_TEMPLATE",

  UI_ORDER_REINITIALIZE_ARTICLE_DEPENDENT_FIELDS = "UI_ORDER_REINITIALIZE_ARTICLE_DEPENDENT_FIELDS",

  NORMALIZE_MIDDLEWARE_SAVE = "NORMALIZE_MIDDLEWARE_SAVE",

  PAGES_PROJECTS = "PAGES_PROJECTS",
  PAGES_PROJECTS_RESET = "PAGES_PROJECTS_RESET",
  PAGES_ACTIVITIES = "PAGES_ACTIVITIES",
  PAGES_ACTIVITIES_RESET = "PAGES_ACTIVITIES_RESET",
  PAGES_ORDER_POSITIONS = "PAGES_ORDER_POSITIONS",
  PAGES_ORDER_POSITIONS_RESET = "PAGES_ORDER_POSITIONS_RESET",

  UI_BASEDATA_DETAILS_ARTICLE_NAVIGATE = "UI_BASEDATA_DETAILS_ARTICLE_NAVIGATE",
  UI_BASEDATA_DETAILS_CUSTOMER_NAVIGATE = "UI_BASEDATA_DETAILS_CUSTOMER_NAVIGATE",
  UI_BASEDATA_DETAILS_RESOURCE_NAVIGATE = "UI_BASEDATA_DETAILS_RESOURCE_NAVIGATE",
  UI_BREADCRUMBS_SET = "UI_BREADCRUMBS_SET",
  UI_BREADCRUMBS_CLEAR = "UI_BREADCRUMBS_CLEAR",
  UI_FILTERS_SET = "UI_FILTERS_SET",
  UI_USER_FILTER_CHANGE = "UI_USER_FILTER_CHANGE",
  UI_PLANNING_OBJECTS_DETAILS_PROJECT_NAVIGATE = "UI_PLANNING_OBJECTS_DETAILS_PROJECT_NAVIGATE",
  UI_PLANNING_OBJECTS_DETAILS_ACTIVITY_NAVIGATE = "UI_PLANNING_OBJECTS_DETAILS_ACTIVITY_NAVIGATE",

  UI_TIMELINE_SHOW_NEXT_RANGE = "UI_TIMELINE_SHOW_NEXT_RANGE",
  UI_TIMELINE_SHOW_PREVIOUS_RANGE = "UI_TIMELINE_SHOW_PREVIOUS_RANGE",
  UI_TIMELINE_SHOW_TODAY = "UI_TIMELINE_SHOW_TODAY",
  UI_TIMELINE_SET_WINDOW_SIZE = "UI_TIMELINE_SET_WINDOW_SIZE",
  UI_TIMELINE_TIMELINE_MOVED = "UI_TIMELINE_TIMELINE_MOVED",
  UI_TIMELINE_RESET = "UI_TIMELINE_RESET",
  UI_TIMELINE_TOGGLE_TOOLTIPS = "UI_TIMELINE_TOGGLE_TOOLTIPS",
  UI_TIMELINE_CLOSE_PLANNING_DRAWER = "UI_TIMELINE_CLOSE_PLANNING_DRAWER",
  UI_TIMELINE_CLOSE_PRODUCTION_DRAWER = "UI_TIMELINE_CLOSE_PRODUCTION_DRAWER",
  UI_TIMELINE_DRAG_COLUMN_HEADER_WIDTH = "UI_TIMELINE_DRAG_COLUMN_HEADER_WIDTH",
  UI_TIMELINE_PLANNING_DETAILS_PROJECT_NAVIGATE = "UI_TIMELINE_PLANNING_DETAILS_PROJECT_NAVIGATE",
  UI_TIMELINE_PLANNING_DETAILS_ORDER_POSITION_NAVIGATE = "UI_TIMELINE_PLANNING_DETAILS_ORDER_POSITION_NAVIGATE",
  UI_TIMELINE_PLANNING_DETAILS_ACTIVITY_NAVIGATE = "UI_TIMELINE_PLANNING_DETAILS_ACTIVITY_NAVIGATE",

  UI_TIMELINE_PRODUCTION_DETAILS_PRODUCTION_ORDER_NAVIGATE = "UI_TIMELINE_PRODUCTION_DETAILS_PRODUCTION_ORDER_NAVIGATE",
  UI_TIMELINE_PRODUCTION_DETAILS_OPERATION_NAVIGATE = "UI_TIMELINE_PRODUCTION_DETAILS_OPERATION_NAVIGATE",

  UI_TIMELINE_TIMELINE_SET_DEFAULT = "UI_TIMELINE_TIMELINE_SET_DEFAULT",

  UI_TIMELINE_TOGGLE_PERSONEL_PLAN = "UI_TIMELINE_TOGGLE_PERSONEL_PLAN",
  UI_TIMELINE_TOGGLE_PRODUCTION_TIMELINE = "UI_TIMELINE_TOGGLE_PRODUCTION_TIMELINE",
  UI_TIMELINE_TOGGLE_RESOURCES_TIMELINE = "UI_TIMELINE_TOGGLE_RESOURCES_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWACTUALQUANTITY_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWACTUALQUANTITY_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWARCHIVEDSOURCES_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWARCHIVEDSOURCES_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWDATEFILTER_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWDATEFILTER_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWDELAYEDCONFLICTS_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWDELAYEDCONFLICTS_TIMELINE",
  UI_TIMELINE_SET_SHOWDATEFILTER_TIMELINE = "UI_TIMELINE_SET_SHOWDATEFILTER_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWFINISHED_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWFINISHED_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWFREERESOURCES_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWFREERESOURCES_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWFINISHEDPROJECTS_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWFINISHEDPROJECTS_TIMELINE",
  UI_TIMELINE_TOGGLE_SHOWVISIBLEAREA_TIMELINE = "UI_TIMELINE_TOGGLE_SHOWVISIBLEAREA_TIMELINE",
  UI_TIMELINE_TOGGLE_ACTIVITY_LOCK = "UI_TIMELINE_TOGGLE_ACTIVITY_LOCK",
  UI_TIMELINE_TOGGLE_OPERATION_LOCK = "UI_TIMELINE_TOGGLE_OPERATION_LOCK",
  UI_TIMELINE_USER_FILTER_SET = "UI_TIMELINE_USER_FILTER_SET",

  UI_TIMELINE_FILTER_CLEAR = "UI_TIMELINE_FILTER_CLEAR",
  UI_TIMELINE_FILTER_UPDATE = "UI_TIMELINE_FILTER_UPDATE",
  TIMELINE_FILTER_FORM_SET_VALUES = "TIMELINE_FILTER_FORM_SET_VALUES",

  UI_TIMELINE_FORCERERENDER_PLANNING_CLEAR = "UI_TIMELINE_FORCERERENDER_PLANNING_CLEAR",
  UI_TIMELINE_FORCERERENDER_PRODUCTION_CLEAR = "UI_TIMELINE_FORCERERENDER_PRODUCTION_CLEAR",
  UI_TIMELINE_FORCERERENDER_RESOURCE_CLEAR = "UI_TIMELINE_FORCERERENDER_RESOURCE_CLEAR",
  UI_TIMELINE_FORCERERENDER = "UI_TIMELINE_FORCERERENDER",

  UI_WORKBENCH_WORKBENCH_SET_DEFAULT = "UI_WORKBENCH_WORKBENCH_SET_DEFAULT",
  UI_WORKBENCH_CHANGE_SHOWFINISHED_OPERATION = "UI_WORKBENCH_CHANGE_SHOWFINISHED_OPERATION",
  UI_WORKBENCH_CHANGE_SHOWPLAUSI_OPERATION = "UI_WORKBENCH_CHANGE_SHOWPLAUSI_OPERATION",
  UI_WORKBENCH_CHANGE_SEARCH_OPERATION = "UI_WORKBENCH_CHANGE_SEARCH_OPERATION",
  UI_WORKBENCH_CHANGE_SHOWFINISHED_ACTIVITY = "UI_WORKBENCH_CHANGE_SHOWFINISHED_ACTIVITY",
  UI_WORKBENCH_CHANGE_SHOWPLAUSI_ACTIVITY = "UI_WORKBENCH_CHANGE_SHOWPLAUSI_ACTIVITY",
  UI_WORKBENCH_CHANGE_SEARCH_ACTIVITY = "UI_WORKBENCH_CHANGE_SEARCH_ACTIVITY",
  UI_WORKBENCH_FILTER_CLEAR_OPERATION = "UI_WORKBENCH_FILTER_CLEAR_OPERATION",
  UI_WORKBENCH_FILTER_CLEAR_ACTIVITY = "UI_WORKBENCH_FILTER_CLEAR_ACTIVITY",
  UI_WORKBENCH_OPERATIONS_FILTER_SET = "UI_WORKBENCH_OPERATIONS_FILTER_SET",
  UI_WORKBENCH_ACTIVITIES_FILTER_SET = "UI_WORKBENCH_ACTIVITIES_FILTER_SET",
  UI_WORKBENCH_PROGRESS_SETTINGS_HIDE_REGISTER_SET = "UI_WORKBENCH_PROGRESS_SETTINGS_HIDE_REGISTER_SET",
  WORKBENCH_FILTER_FORM_SET_VALUES = "WORKBENCH_FILTER_FORM_SET_VALUES",

  UI_AVAILABLE_HOURS_PER_DAY_FILTER_CLEAR = "UI_AVAILABLE_HOURS_PER_DAY_FILTER_CLEAR",
  UI_AVAILABLE_HOURS_PER_DAY_FILTER_SET = "UI_AVAILABLE_HOURS_PER_DAY_FILTER_SET",
  UI_AVAILABLE_HOURS_PER_DAY_SET_VALUES = "UI_AVAILABLE_HOURS_PER_DAY_SET_VALUES",
  UI_AVAILABLE_HOURS_PER_DAY_USER_FILTER_SET = "UI_AVAILABLE_HOURS_PER_DAY_USER_FILTER_SET",

  USER_LOGIN = "USER_LOGIN",
  USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST",
  USER_LOGIN_DO_REQUEST = "USER_LOGIN_DO_REQUEST",
  USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE",

  USER_LOGOUT = "USER_LOGOUT",
  USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST",
  USER_LOGOUT_DO_REQUEST = "USER_LOGOUT_DO_REQUEST",
  USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS",
  USER_LOGOUT_FAILURE = "USER_LOGOUT_FAILURE",

  IMPORTS_LIST = "IMPORTS_LIST",
  IMPORTS_LIST_REQUEST = "IMPORTS_LIST_REQUEST",
  IMPORTS_LIST_DO_REQUEST = "IMPORTS_LIST_DO_REQUEST",
  IMPORTS_LIST_SUCCESS = "IMPORTS_LIST_SUCCESS",
  IMPORTS_LIST_FAILURE = "IMPORTS_LIST_FAILURE",

  IMPORTS_UPLOAD = "IMPORTS_UPLOAD",
  IMPORTS_UPLOAD_REQUEST = "IMPORTS_UPLOAD_REQUEST",
  IMPORTS_UPLOAD_DO_REQUEST = "IMPORTS_UPLOAD_DO_REQUEST",
  IMPORTS_UPLOAD_SUCCESS = "IMPORTS_UPLOAD_SUCCESS",
  IMPORTS_UPLOAD_FAILURE = "IMPORTS_UPLOAD_FAILURE",

  IMPORTS_VALIDATE = "IMPORTS_VALIDATE",
  IMPORTS_VALIDATE_REQUEST = "IMPORTS_VALIDATE_REQUEST",
  IMPORTS_VALIDATE_DO_REQUEST = "IMPORTS_VALIDATE_DO_REQUEST",
  IMPORTS_VALIDATE_SUCCESS = "IMPORTS_VALIDATE_SUCCESS",
  IMPORTS_VALIDATE_FAILURE = "IMPORTS_VALIDATE_FAILURE",

  IMPORTS_PROCESS = "IMPORTS_PROCESS",
  IMPORTS_PROCESS_REQUEST = "IMPORTS_PROCESS_REQUEST",
  IMPORTS_PROCESS_DO_REQUEST = "IMPORTS_PROCESS_DO_REQUEST",
  IMPORTS_PROCESS_SUCCESS = "IMPORTS_PROCESS_SUCCESS",
  IMPORTS_PROCESS_FAILURE = "IMPORTS_PROCESS_FAILURE",

  USER_AUTO_LOGIN_FAILURE = "USER_AUTO_LOGIN_FAILURE",
  USER_AUTO_LOGIN_SUCCESS = "USER_AUTO_LOGIN_SUCCESS",
  USER_AUTO_LOGIN_TERMINAL_SUCCESS = "USER_AUTO_LOGIN_TERMINAL_SUCCESS",
  USER_AUTO_LOGIN_TERMINAL_FAILURE = "USER_AUTO_LOGIN_TERMINAL_FAILURE",
  USER_LOGIN_CHECK = "USER_LOGIN_CHECK",

  USER_TERMINAL_LOGIN_SUCCESS = "USER_TERMINAL_LOGIN_SUCCESS",
  USER_TERMINAL_LOGIN_FAILURE = "USER_TERMINAL_LOGIN_FAILURE",

  IMPORTS_BACK_TO_IMPORT = "IMPORTS_BACK_TO_IMPORT",
  IMPORTS_CLEAR_FILE = "IMPORTS_CLEAR_FILE",
  IMPORTS_RESET = "IMPORTS_RESET",
  IMPORTS_TYPE_SELECT = "IMPORTS_TYPE_SELECT",

  PAGES_REPORT_PARAMETERS_SAVE = "PAGES_REPORT_PARAMETERS_SAVE",
  PAGES_REPORT_SETTINGS_SAVE = "PAGES_REPORT_SETTINGS_SAVE",

  ACCESSIBLE_LICENCE_MODULES_LIST = "ACCESSIBLE_LICENCE_MODULES_LIST",
  ACCESSIBLE_LICENCE_MODULES_LIST_REQUEST = "ACCESSIBLE_LICENCE_MODULES_LIST_REQUEST",
  ACCESSIBLE_LICENCE_MODULES_LIST_DO_REQUEST = "ACCESSIBLE_LICENCE_MODULES_LIST_DO_REQUEST",
  ACCESSIBLE_LICENCE_MODULES_LIST_SUCCESS = "ACCESSIBLE_LICENCE_MODULES_LIST_SUCCESS",
  ACCESSIBLE_LICENCE_MODULES_LIST_FAILURE = "ACCESSIBLE_LICENCE_MODULES_LIST_FAILURE",
  ADDITIONAL_PROPERTIES_SUCCESS = "ADDITIONAL_PROPERTIES_SUCCESS",

  LICENCE_MODULES_LIST = "LICENCE_MODULES_LIST",
  LICENCE_MODULES_LIST_REQUEST = "LICENCE_MODULES_LIST_REQUEST",
  LICENCE_MODULES_LIST_DO_REQUEST = "LICENCE_MODULES_LIST_DO_REQUEST",
  LICENCE_MODULES_LIST_SUCCESS = "LICENCE_MODULES_LIST_SUCCESS",
  LICENCE_MODULES_LIST_FAILURE = "LICENCE_MODULES_LIST_FAILURE",

  LICENCE_MODULES_EXIST = "LICENCE_MODULES_EXIST",
  LICENCE_MODULES_EXIST_REQUEST = "LICENCE_MODULES_EXIST_REQUEST",
  LICENCE_MODULES_EXIST_DO_REQUEST = "LICENCE_MODULES_EXIST_DO_REQUEST",
  LICENCE_MODULES_EXIST_SUCCESS = "LICENCE_MODULES_EXIST_SUCCESS",
  LICENCE_MODULES_EXIST_FAILURE = "LICENCE_MODULES_EXIST_FAILURE",

  LICENCE_MODULES_DETAILS = "LICENCE_MODULES_DETAILS",
  LICENCE_MODULES_DETAILS_REQUEST = "LICENCE_MODULES_DETAILS_REQUEST",
  LICENCE_MODULES_DETAILS_DO_REQUEST = "LICENCE_MODULES_DETAILS_DO_REQUEST",
  LICENCE_MODULES_DETAILS_SUCCESS = "LICENCE_MODULES_DETAILS_SUCCESS",
  LICENCE_MODULES_DETAILS_FAILURE = "LICENCE_MODULES_DETAILS_FAILURE",

  LICENCE_MODULES_ADD = "LICENCE_MODULES_ADD",
  LICENCE_MODULES_ADD_REQUEST = "LICENCE_MODULES_ADD_REQUEST",
  LICENCE_MODULES_ADD_DO_REQUEST = "LICENCE_MODULES_ADD_DO_REQUEST",
  LICENCE_MODULES_ADD_SUCCESS = "LICENCE_MODULES_ADD_SUCCESS",
  LICENCE_MODULES_ADD_FAILURE = "LICENCE_MODULES_ADD_FAILURE",
  LICENCE_MODULES_ADD_FORM_ERROR_RESET = "LICENCE_MODULES_ADD_FORM_ERROR_RESET",

  LICENCE_MODULES_DETAILS_UPDATE = "LICENCE_MODULES_DETAILS_UPDATE",
  LICENCE_MODULES_DETAILS_UPDATE_REQUEST = "LICENCE_MODULES_DETAILS_UPDATE_REQUEST",
  LICENCE_MODULES_DETAILS_UPDATE_DO_REQUEST = "LICENCE_MODULES_DETAILS_UPDATE_DO_REQUEST",
  LICENCE_MODULES_DETAILS_UPDATE_SUCCESS = "LICENCE_MODULES_DETAILS_UPDATE_SUCCESS",
  LICENCE_MODULES_DETAILS_UPDATE_FAILURE = "LICENCE_MODULES_DETAILS_UPDATE_FAILURE",

  USER_LANGUAGES = "USER_LANGUAGES",
  USER_LANGUAGES_REQUEST = "USER_LANGUAGES_REQUEST",
  USER_LANGUAGES_DO_REQUEST = "USER_LANGUAGES_DO_REQUEST",
  USER_LANGUAGES_SUCCESS = "USER_LANGUAGES_SUCCESS",
  USER_LANGUAGES_FAILURE = "USER_LANGUAGES_FAILURE",

  USER_RIGHTS = "USER_RIGHTS",
  USER_RIGHTS_REQUEST = "USER_RIGHTS_REQUEST",
  USER_RIGHTS_DO_REQUEST = "USER_RIGHTS_DO_REQUEST",
  USER_RIGHTS_SUCCESS = "USER_RIGHTS_SUCCESS",
  USER_RIGHTS_FAILURE = "USER_RIGHTS_FAILURE",

  USERS_LIST = "USERS_LIST",
  USERS_LIST_REQUEST = "USERS_LIST_REQUEST",
  USERS_LIST_DO_REQUEST = "USERS_LIST_DO_REQUEST",
  USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS",
  USERS_LIST_FAILURE = "USERS_LIST_FAILURE",

  USERS_DETAILS = "USERS_DETAILS",
  USERS_DETAILS_REQUEST = "USERS_DETAILS_REQUEST",
  USERS_DETAILS_DO_REQUEST = "USERS_DETAILS_DO_REQUEST",
  USERS_DETAILS_SUCCESS = "USERS_DETAILS_SUCCESS",
  USERS_DETAILS_FAILURE = "USERS_DETAILS_FAILURE",

  USERS_ADD = "USERS_ADD",
  USERS_ADD_REQUEST = "USERS_ADD_REQUEST",
  USERS_ADD_DO_REQUEST = "USERS_ADD_DO_REQUEST",
  USERS_ADD_SUCCESS = "USERS_ADD_SUCCESS",
  USERS_ADD_FAILURE = "USERS_ADD_FAILURE",

  USERS_DELETE = "USERS_DELETE",
  USERS_DELETE_REQUEST = "USERS_DELETE_REQUEST",
  USERS_DELETE_DO_REQUEST = "USERS_DELETE_DO_REQUEST",
  USERS_DELETE_SUCCESS = "USERS_DELETE_SUCCESS",
  USERS_DELETE_FAILURE = "USERS_DELETE_FAILURE",

  USERS_UPDATE = "USERS_UPDATE",
  USERS_UPDATE_REQUEST = "USERS_UPDATE_REQUEST",
  USERS_UPDATE_DO_REQUEST = "USERS_UPDATE_DO_REQUEST",
  USERS_UPDATE_SUCCESS = "USERS_UPDATE_SUCCESS",
  USERS_UPDATE_FAILURE = "USERS_UPDATE_FAILURE",

  USERS_CHANGE_PASSWORD = "USERS_CHANGE_PASSWORD",
  USERS_CHANGE_PASSWORD_REQUEST = "USERS_CHANGE_PASSWORD_REQUEST",
  USERS_CHANGE_PASSWORD_DO_REQUEST = "USERS_CHANGE_PASSWORD_DO_REQUEST",
  USERS_CHANGE_PASSWORD_SUCCESS = "USERS_CHANGE_PASSWORD_SUCCESS",
  USERS_CHANGE_PASSWORD_FAILURE = "USERS_CHANGE_PASSWORD_FAILURE",

  USER_CHANGE_LANGUAGE = "USER_CHANGE_LANGUAGE",
  USER_CHANGE_LANGUAGE_REQUEST = "USER_CHANGE_LANGUAGE_REQUEST",
  USER_CHANGE_LANGUAGE_DO_REQUEST = "USER_CHANGE_LANGUAGE_DO_REQUEST",
  USER_CHANGE_LANGUAGE_SUCCESS = "USER_CHANGE_LANGUAGE_SUCCESS",
  USER_CHANGE_LANGUAGE_FAILURE = "USER_CHANGE_LANGUAGE_FAILURE",

  DASHBOARD_ROLES_LIST = "DASHBOARD_ROLES_LIST",
  DASHBOARD_ROLES_LIST_REQUEST = "DASHBOARD_ROLES_LIST_REQUEST",
  DASHBOARD_ROLES_LIST_DO_REQUEST = "DASHBOARD_ROLES_LIST_DO_REQUEST",
  DASHBOARD_ROLES_LIST_SUCCESS = "DASHBOARD_ROLES_LIST_SUCCESS",
  DASHBOARD_ROLES_LIST_FAILURE = "DASHBOARD_ROLES_LIST_FAILURE",

  MODULES_LIST = "MODULES_LIST",
  MODULES_LIST_REQUEST = "MODULES_LIST_REQUEST",
  MODULES_LIST_DO_REQUEST = "MODULES_LIST_DO_REQUEST",
  MODULES_LIST_SUCCESS = "MODULES_LIST_SUCCESS",
  MODULES_LIST_FAILURE = "MODULES_LIST_FAILURE",

  BASEDATA_CUSTOMERS_LIST = "BASEDATA_CUSTOMERS_LIST",
  BASEDATA_CUSTOMERS_LIST_REQUEST = "BASEDATA_CUSTOMERS_LIST_REQUEST",
  BASEDATA_CUSTOMERS_LIST_DO_REQUEST = "BASEDATA_CUSTOMERS_LIST_DO_REQUEST",
  BASEDATA_CUSTOMERS_LIST_SUCCESS = "BASEDATA_CUSTOMERS_LIST_SUCCESS",
  BASEDATA_CUSTOMERS_LIST_FAILURE = "BASEDATA_CUSTOMERS_LIST_FAILURE",

  BASEDATA_TEMPLATES_LIST = "BASEDATA_TEMPLATES_LIST",
  BASEDATA_TEMPLATES_LIST_REQUEST = "BASEDATA_TEMPLATES_LIST_REQUEST",
  BASEDATA_TEMPLATES_LIST_DO_REQUEST = "BASEDATA_TEMPLATES_LIST_DO_REQUEST",
  BASEDATA_TEMPLATES_LIST_SUCCESS = "BASEDATA_TEMPLATES_LIST_SUCCESS",
  BASEDATA_TEMPLATES_LIST_FAILURE = "BASEDATA_TEMPLATES_LIST_FAILURE",

  BASEDATA_TEMPLATE_DETAILS_LIST = "BASEDATA_TEMPLATE_DETAILS_LIST",
  BASEDATA_TEMPLATE_DETAILS_LIST_REQUEST = "BASEDATA_TEMPLATE_DETAILS_LIST_REQUEST",
  BASEDATA_TEMPLATE_DETAILS_LIST_DO_REQUEST = "BASEDATA_TEMPLATE_DETAILS_LIST_DO_REQUEST",
  BASEDATA_TEMPLATE_DETAILS_LIST_SUCCESS = "BASEDATA_TEMPLATE_DETAILS_LIST_SUCCESS",
  BASEDATA_TEMPLATE_DETAILS_LIST_FAILURE = "BASEDATA_TEMPLATE_DETAILS_LIST_FAILURE",

  BASEDATA_TEMPLATE_DETAILS_UPDATE = "BASEDATA_TEMPLATE_DETAILS_UPDATE",
  BASEDATA_TEMPLATE_DETAILS_UPDATE_REQUEST = "BASEDATA_TEMPLATE_DETAILS_UPDATE_REQUEST",
  BASEDATA_TEMPLATE_DETAILS_UPDATE_DO_REQUEST = "BASEDATA_TEMPLATE_DETAILS_UPDATE_DO_REQUEST",
  BASEDATA_TEMPLATE_DETAILS_UPDATE_SUCCESS = "BASEDATA_TEMPLATE_DETAILS_UPDATE_SUCCESS",
  BASEDATA_TEMPLATE_DETAILS_UPDATE_FAILURE = "BASEDATA_TEMPLATE_DETAILS_UPDATE_FAILURE",

  BASEDATA_STATUS_LIST = "BASEDATA_STATUS_LIST",
  BASEDATA_STATUS_LIST_REQUEST = "BASEDATA_STATUS_LIST_REQUEST",
  BASEDATA_STATUS_LIST_DO_REQUEST = "BASEDATA_STATUS_LIST_DO_REQUEST",
  BASEDATA_STATUS_LIST_SUCCESS = "BASEDATA_STATUS_LIST_SUCCESS",
  BASEDATA_STATUS_LIST_FAILURE = "BASEDATA_STATUS_LIST_FAILURE",

  BASEDATA_TECHNOLOGIES_LIST = "BASEDATA_TECHNOLOGIES_LIST",
  BASEDATA_TECHNOLOGIES_LIST_REQUEST = "BASEDATA_TECHNOLOGIES_LIST_REQUEST",
  BASEDATA_TECHNOLOGIES_LIST_DO_REQUEST = "BASEDATA_TECHNOLOGIES_LIST_DO_REQUEST",
  BASEDATA_TECHNOLOGIES_LIST_SUCCESS = "BASEDATA_TECHNOLOGIES_LIST_SUCCESS",
  BASEDATA_TECHNOLOGIES_LIST_FAILURE = "BASEDATA_TECHNOLOGIES_LIST_FAILURE",

  BASEDATA_TECHNOLOGY_DETAILS_LOAD = "BASEDATA_TECHNOLOGY_DETAILS_LOAD",
  BASEDATA_TECHNOLOGY_DETAILS_LOAD_REQUEST = "BASEDATA_TECHNOLOGY_DETAILS_LOAD_REQUEST",
  BASEDATA_TECHNOLOGY_DETAILS_LOAD_DO_REQUEST = "BASEDATA_TECHNOLOGY_DETAILS_LOAD_DO_REQUEST",
  BASEDATA_TECHNOLOGY_DETAILS_LOAD_SUCCESS = "BASEDATA_TECHNOLOGY_DETAILS_LOAD_SUCCESS",
  BASEDATA_TECHNOLOGY_DETAILS_LOAD_FAILURE = "BASEDATA_TECHNOLOGY_DETAILS_LOAD_FAILURE",

  BASEDATA_TECHNOLOGY_DETAILS_UPDATE = "BASEDATA_TECHNOLOGY_DETAILS_UPDATE",
  BASEDATA_TECHNOLOGY_DETAILS_UPDATE_REQUEST = "BASEDATA_TECHNOLOGY_DETAILS_UPDATE_REQUEST",
  BASEDATA_TECHNOLOGY_DETAILS_UPDATE_DO_REQUEST = "BASEDATA_TECHNOLOGY_DETAILS_UPDATE_DO_REQUEST",
  BASEDATA_TECHNOLOGY_DETAILS_UPDATE_SUCCESS = "BASEDATA_TECHNOLOGY_DETAILS_UPDATE_SUCCESS",
  BASEDATA_TECHNOLOGY_DETAILS_UPDATE_FAILURE = "BASEDATA_TECHNOLOGY_DETAILS_UPDATE_FAILURE",

  BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST = "BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST",
  BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_REQUEST = "BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_REQUEST",
  BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_DO_REQUEST = "BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_DO_REQUEST",
  BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_SUCCESS = "BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_SUCCESS",
  BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_FAILURE = "BASEDATA_ARTICLE_TEMPLATE_DETAILS_LIST_FAILURE",

  BASEDATA_RESOURCES_LIST = "BASEDATA_RESOURCES_LIST",
  BASEDATA_RESOURCES_LIST_REQUEST = "BASEDATA_RESOURCES_LIST_REQUEST",
  BASEDATA_RESOURCES_LIST_DO_REQUEST = "BASEDATA_RESOURCES_LIST_DO_REQUEST",
  BASEDATA_RESOURCES_LIST_SUCCESS = "BASEDATA_RESOURCES_LIST_SUCCESS",
  BASEDATA_RESOURCES_LIST_FAILURE = "BASEDATA_RESOURCES_LIST_FAILURE",

  BASEDATA_RESOURCES_UPDATE = "BASEDATA_RESOURCES_UPDATE",
  BASEDATA_RESOURCES_UPDATE_REQUEST = "BASEDATA_RESOURCES_UPDATE_REQUEST",
  BASEDATA_RESOURCES_UPDATE_DO_REQUEST = "BASEDATA_RESOURCES_UPDATE_DO_REQUEST",
  BASEDATA_RESOURCES_UPDATE_SUCCESS = "BASEDATA_RESOURCES_UPDATE_SUCCESS",
  BASEDATA_RESOURCES_UPDATE_FAILURE = "BASEDATA_RESOURCES_UPDATE_FAILURE",

  BASEDATA_RESOURCE_DETAILS_LOAD = "BASEDATA_RESOURCE_DETAILS_LOAD",
  BASEDATA_RESOURCE_DETAILS_LOAD_REQUEST = "BASEDATA_RESOURCE_DETAILS_LOAD_REQUEST",
  BASEDATA_RESOURCE_DETAILS_LOAD_DO_REQUEST = "BASEDATA_RESOURCE_DETAILS_LOAD_DO_REQUEST",
  BASEDATA_RESOURCE_DETAILS_LOAD_SUCCESS = "BASEDATA_RESOURCE_DETAILS_LOAD_SUCCESS",
  BASEDATA_RESOURCE_DETAILS_LOAD_FAILURE = "BASEDATA_RESOURCE_DETAILS_LOAD_FAILURE",

  BASEDATA_RESOURCE_DETAILS_CREATE = "BASEDATA_RESOURCE_DETAILS_CREATE",
  BASEDATA_RESOURCE_DETAILS_CREATE_REQUEST = "BASEDATA_RESOURCE_DETAILS_CREATE_REQUEST",
  BASEDATA_RESOURCE_DETAILS_CREATE_DO_REQUEST = "BASEDATA_RESOURCE_DETAILS_CREATE_DO_REQUEST",
  BASEDATA_RESOURCE_DETAILS_CREATE_SUCCESS = "BASEDATA_RESOURCE_DETAILS_CREATE_SUCCESS",
  BASEDATA_RESOURCE_DETAILS_CREATE_FAILURE = "BASEDATA_RESOURCE_DETAILS_CREATE_FAILURE",

  BASEDATA_RESOURCE_DETAILS_UPDATE = "BASEDATA_RESOURCE_DETAILS_UPDATE",
  BASEDATA_RESOURCE_DETAILS_UPDATE_REQUEST = "BASEDATA_RESOURCE_DETAILS_UPDATE_REQUEST",
  BASEDATA_RESOURCE_DETAILS_UPDATE_DO_REQUEST = "BASEDATA_RESOURCE_DETAILS_UPDATE_DO_REQUEST",
  BASEDATA_RESOURCE_DETAILS_UPDATE_SUCCESS = "BASEDATA_RESOURCE_DETAILS_UPDATE_SUCCESS",
  BASEDATA_RESOURCE_DETAILS_UPDATE_FAILURE = "BASEDATA_RESOURCE_DETAILS_UPDATE_FAILURE",

  BASEDATA_PUBLIC_HOLIDAYS_LIST = "BASEDATA_PUBLIC_HOLIDAYS_LIST",
  BASEDATA_PUBLIC_HOLIDAYS_LIST_REQUEST = "BASEDATA_PUBLIC_HOLIDAYS_LIST_REQUEST",
  BASEDATA_PUBLIC_HOLIDAYS_LIST_DO_REQUEST = "BASEDATA_PUBLIC_HOLIDAYS_LIST_DO_REQUEST",
  BASEDATA_PUBLIC_HOLIDAYS_LIST_SUCCESS = "BASEDATA_PUBLIC_HOLIDAYS_LIST_SUCCESS",
  BASEDATA_PUBLIC_HOLIDAYS_LIST_FAILURE = "BASEDATA_PUBLIC_HOLIDAYS_LIST_FAILURE",

  PLANNING_OBJECTS_PROJECT_DETAILS_LOAD = "PLANNING_OBJECTS_PROJECT_DETAILS_LOAD",
  PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_DO_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_DO_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_SUCCESS = "PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_SUCCESS",
  PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_FAILURE = "PLANNING_OBJECTS_PROJECT_DETAILS_LOAD_FAILURE",

  PLANNING_OBJECTS_PROJECT_DETAILS_CREATE = "PLANNING_OBJECTS_PROJECT_DETAILS_CREATE",
  PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_DO_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_DO_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_SUCCESS = "PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_SUCCESS",
  PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_FAILURE = "PLANNING_OBJECTS_PROJECT_DETAILS_CREATE_FAILURE",

  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK",
  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_CANCEL_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_CANCEL_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_DO_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_DO_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_SUCCESS = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_SUCCESS",
  PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_FAILURE = "PLANNING_OBJECTS_PROJECT_DETAILS_CHECK_FAILURE",

  PLANNING_OBJECTS_TERMINATIONS_LIST = "PLANNING_OBJECTS_TERMINATIONS_LIST",
  PLANNING_OBJECTS_TERMINATIONS_LIST_REQUEST = "PLANNING_OBJECTS_TERMINATIONS_LIST_REQUEST",
  PLANNING_OBJECTS_TERMINATIONS_LIST_DO_REQUEST = "PLANNING_OBJECTS_TERMINATIONS_LIST_DO_REQUEST",
  PLANNING_OBJECTS_TERMINATIONS_LIST_SUCCESS = "PLANNING_OBJECTS_TERMINATIONS_LIST_SUCCESS",
  PLANNING_OBJECTS_TERMINATIONS_LIST_FAILURE = "PLANNING_OBJECTS_TERMINATIONS_LIST_FAILURE",

  PLANNING_OBJECTS_AMOUNT_UNITS_LIST = "PLANNING_OBJECTS_AMOUNT_UNITS_LIST",
  PLANNING_OBJECTS_AMOUNT_UNITS_LIST_REQUEST = "PLANNING_OBJECTS_AMOUNT_UNITS_LIST_REQUEST",
  PLANNING_OBJECTS_AMOUNT_UNITS_LIST_DO_REQUEST = "PLANNING_OBJECTS_AMOUNT_UNITS_LIST_DO_REQUEST",
  PLANNING_OBJECTS_AMOUNT_UNITS_LIST_SUCCESS = "PLANNING_OBJECTS_AMOUNT_UNITS_LIST_SUCCESS",
  PLANNING_OBJECTS_AMOUNT_UNITS_LIST_FAILURE = "PLANNING_OBJECTS_AMOUNT_UNITS_LIST_FAILURE",

  PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD = "PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_DO_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_DO_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_SUCCESS = "PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_SUCCESS",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_FAILURE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_LOAD_FAILURE",

  PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_DO_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_DO_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_SUCCESS = "PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_SUCCESS",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_FAILURE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_UPDATE_FAILURE",

  PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_DO_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_DO_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_SUCCESS = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_SUCCESS",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_FAILURE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CREATE_FAILURE",

  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_CANCEL_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_CANCEL_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_DO_REQUEST = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_DO_REQUEST",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_SUCCESS = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_SUCCESS",
  PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_FAILURE = "PLANNING_OBJECTS_ACTIVITY_DETAILS_CHECK_FAILURE",

  PLANNING_OBJECTS_OPERATION_DETAILS_LOAD = "PLANNING_OBJECTS_OPERATION_DETAILS_LOAD",
  PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_REQUEST = "PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_REQUEST",
  PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_DO_REQUEST = "PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_DO_REQUEST",
  PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_SUCCESS = "PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_SUCCESS",
  PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_FAILURE = "PLANNING_OBJECTS_OPERATION_DETAILS_LOAD_FAILURE",

  PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE = "PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE",
  PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_REQUEST = "PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_REQUEST",
  PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_DO_REQUEST = "PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_DO_REQUEST",
  PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_SUCCESS = "PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_SUCCESS",
  PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_FAILURE = "PLANNING_OBJECTS_OPERATION_DETAILS_UPDATE_FAILURE",

  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_REQUEST = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_DO_REQUEST = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_DO_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_SUCCESS = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_SUCCESS",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_FAILURE = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_FAILURE",

  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_REQUEST = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_DO_REQUEST = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_DO_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_SUCCESS = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_SUCCESS",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_FAILURE = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_UPDATE_FAILURE",

  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN",
  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_REQUEST = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_DO_REQUEST = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_DO_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_SUCCESS = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_SUCCESS",
  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_FAILURE = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_FAILURE",

  PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_SEQUENCE = "PLANNING_OBJECTS_ORDER_POSITIONS_PLAN_SEQUENCE",
  PLANNING_OBJECTS_ORDER_POSITION_REMOVE = "PLANNING_OBJECTS_ORDER_POSITION_REMOVE",

  PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN = "PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN",
  PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_REQUEST = "PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_DO_REQUEST = "PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_DO_REQUEST",
  PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_SUCCESS = "PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_SUCCESS",
  PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_FAILURE = "PLANNING_OBJECTS_ORDER_POSITIONS_REVOKE_PLAN_FAILURE",
  PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_RESET = "PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD_RESET",

  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_DO_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_DO_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_SUCCESS = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_SUCCESS",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_FAILURE = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_FAILURE",

  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_DO_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_DO_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_SUCCESS = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_SUCCESS",
  PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_FAILURE = "PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_FAILURE",

  PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE = "PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE",
  PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_DO_REQUEST = "PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_DO_REQUEST",
  PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_SUCCESS = "PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_SUCCESS",
  PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_FAILURE = "PLANNING_OBJECTS_PRODUCTION_ORDER_REVOKE_FAILURE",

  PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE = "PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE",
  PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_DO_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_DO_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_SUCCESS = "PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_SUCCESS",
  PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_FAILURE = "PLANNING_OBJECTS_PROJECT_DETAILS_UPDATE_FAILURE",

  PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE = "PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE",
  PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_DO_REQUEST = "PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_DO_REQUEST",
  PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_SUCCESS = "PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_SUCCESS",
  PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_FAILURE = "PLANNING_OBJECTS_PROJECT_DETAILS_REVOKE_FAILURE",

  PLANNING_OBJECTS_DELETE = "PLANNING_OBJECTS_DELETE",
  PLANNING_OBJECTS_DELETE_REQUEST = "PLANNING_OBJECTS_DELETE_REQUEST",
  PLANNING_OBJECTS_DELETE_DO_REQUEST = "PLANNING_OBJECTS_DELETE_DO_REQUEST",
  PLANNING_OBJECTS_DELETE_SUCCESS = "PLANNING_OBJECTS_DELETE_SUCCESS",
  PLANNING_OBJECTS_DELETE_FAILURE = "PLANNING_OBJECTS_DELETE_FAILURE",

  DASHBOARD_ORDER_POSITIONS_LIST = "DASHBOARD_ORDER_POSITIONS_LIST",
  DASHBOARD_ORDER_POSITIONS_LIST_REQUEST = "DASHBOARD_ORDER_POSITIONS_LIST_REQUEST",
  DASHBOARD_ORDER_POSITIONS_LIST_DO_REQUEST = "DASHBOARD_ORDER_POSITIONS_LIST_DO_REQUEST",
  DASHBOARD_ORDER_POSITIONS_LIST_SUCCESS = "DASHBOARD_ORDER_POSITIONS_LIST_SUCCESS",
  DASHBOARD_ORDER_POSITIONS_LIST_FAILURE = "DASHBOARD_ORDER_POSITIONS_LIST_FAILURE",

  TIMELINE_DATA_FETCH = "TIMELINE_DATA_FETCH",
  TIMELINE_DATA_FETCH_REQUEST = "TIMELINE_DATA_FETCH_REQUEST",
  TIMELINE_DATA_FETCH_DO_REQUEST = "TIMELINE_DATA_FETCH_DO_REQUEST",
  TIMELINE_DATA_FETCH_SUCCESS = "TIMELINE_DATA_FETCH_SUCCESS",
  TIMELINE_DATA_FETCH_FAILURE = "TIMELINE_DATA_FETCH_FAILURE",

  REPORTS_FETCH = "REPORTS_FETCH",
  REPORTS_FETCH_REQUEST = "REPORTS_FETCH_REQUEST",
  REPORTS_FETCH_DO_REQUEST = "REPORTS_FETCH_DO_REQUEST",
  REPORTS_FETCH_SUCCESS = "REPORTS_FETCH_SUCCESS",
  REPORTS_FETCH_FAILURE = "REPORTS_FETCH_FAILURE",

  GLOBALSETTINGS_FETCH_SUCCESS = "GLOBALSETTINGS_FETCH_SUCCESS",

  PIN_LOGIN = "PIN_LOGIN",
  PIN_LOGIN_REQUEST = "PIN_LOGIN_REQUEST",
  PIN_LOGIN_DO_REQUEST = "PIN_LOGIN_DO_REQUEST",
  PIN_LOGIN_SUCCESS = "PIN_LOGIN_SUCCESS",
  PIN_LOGIN_FAILURE = "PIN_LOGIN_FAILURE",

  SCREEN_LOGIN = "SCREEN_LOGIN",
  SCREEN_LOGIN_REQUEST = "SCREEN_LOGIN_REQUEST",
  SCREEN_LOGIN_DO_REQUEST = "SCREEN_LOGIN_DO_REQUEST",
  SCREEN_LOGIN_SUCCESS = "SCREEN_LOGIN_SUCCESS",
  SCREEN_LOGIN_FAILURE = "SCREEN_LOGIN_FAILURE",
  SCREEN_SET_LANGUAGE = "SCREEN_SET_LANGUAGE",
  PIN_AUTO_LOGIN = "PIN_AUTO_LOGIN",
  SET_TERMINAL_ID = "SET_TERMINAL_ID",
  SET_SCREEN_ID = "SET_SCREEN_ID",

  SCREEN_LOCK = "SCREEN_LOCK",
  SCREEN_LOCK_REQUEST = "SCREEN_LOCK_REQUEST",
  SCREEN_LOCK_DO_REQUEST = "SCREEN_LOCK_DO_REQUEST",
  SCREEN_LOCK_SUCCESS = "SCREEN_LOCK_SUCCESS",
  SCREEN_LOCK_FAILURE = "SCREEN_LOCK_FAILURE",

  TERMINAL_LOCK = "TERMINAL_LOCK",
  TERMINAL_LOCK_REQUEST = "TERMINAL_LOCK_REQUEST",
  TERMINAL_LOCK_DO_REQUEST = "TERMINAL_LOCK_DO_REQUEST",
  TERMINAL_LOCK_SUCCESS = "TERMINAL_LOCK_SUCCESS",
  TERMINAL_LOCK_FAILURE = "TERMINAL_LOCK_FAILURE",

  LOGOUT_TO_TERMINAL = "LOGOUT_TO_TERMINAL",
  LOGOUT_TO_TERMINAL_REQUEST = "LOGOUT_TO_TERMINAL_REQUEST",
  LOGOUT_TO_TERMINAL_DO_REQUEST = "LOGOUT_TO_TERMINAL_DO_REQUEST",
  LOGOUT_TO_TERMINAL_SUCCESS = "LOGOUT_TO_TERMINAL_SUCCESS",
  LOGOUT_TO_TERMINAL_FAILURE = "LOGOUT_TO_TERMINAL_FAILURE",

  TERMINAL_SET_SEARCH = "TERMINAL_SET_SEARCH",
  TERMINAL_SET_SHOW_FINISHED = "TERMINAL_SET_SHOW_FINISHED",
  TERMINAL_SET_SHOW_NEXT_DAYS = "TERMINAL_SET_SHOW_NEXT_DAYS",
  TERMINAL_SET_SHOW_WORKER = "TERMINAL_SET_SHOW_WORKER",
  TERMINAL_SET_SHOW_PLAUSI = "TERMINAL_SET_SHOW_PLAUSI",
  TERMINAL_SET_REJECTTYPE = "TERMINAL_SET_REJECTTYPE",
  TERMINAL_SET_TROUBLETYPE = "TERMINAL_SET_TROUBLETYPE",
  TERMINAL_SET_RESOURCE_TYPE = "TERMINAL_SET_RESOURCE_TYPE",
  TERMINAL_SET_PROGRESS_DATA = "TERMINAL_SET_PROGRESS_DATA",

  TIMELINE_ITEM_CLONE = "TIMELINE_ITEM_CLONE",
  TIMELINE_ITEM_CLONED = "TIMELINE_ITEM_CLONED",
  TIMELINE_ITEM_UPDATE = "TIMELINE_ITEM_UPDATE",
  TIMELINE_UNDO = "TIMELINE_UNDO",
  TIMELINE_ACTIVITY_MOVE = "TIMELINE_ACTIVITY_MOVE",
  TIMELINE_ACTIVITY_MOVE_PREVIEW = "TIMELINE_ACTIVITY_MOVE_PREVIEW",
  TIMELINE_ACTIVITY_MOVE_PREVIEW_CLEAR = "TIMELINE_ACTIVITY_MOVE_PREVIEW_CLEAR",
  TIMELINE_OPERATION_MOVE = "TIMELINE_OPERATION_MOVE",
  TIMELINE_OPERATIONS_FREE_MOVE = "TIMELINE_OPERATIONS_FREE_MOVE",
  TIMELINE_PARALLEL_OPERATION_MOVE = "TIMELINE_PARALLEL_OPERATION_MOVE",
  TIMELINE_OPERATION_MOVE_PREVIEW = "TIMELINE_OPERATION_MOVE_PREVIEW",
  TIMELINE_OPERATION_MOVE_PREVIEW_CLEAR = "TIMELINE_OPERATION_MOVE_PREVIEW_CLEAR",
  TIMELINE_PRODUCTIONORDER_MOVE = "TIMELINE_PRODUCTIONORDER_MOVE",
  TIMELINE_PROJECT_MOVE = "TIMELINE_PROJECT_MOVE",

  TIMELINE_ACTIVITY_RESIZE = "TIMELINE_ACTIVITY_RESIZE",
  TIMELINE_OPERATION_RESIZE = "TIMELINE_OPERATION_RESIZE",
  TIMELINE_PROJECT_RESIZE = "TIMELINE_PROJECT_RESIZE",

  TIMELINE_SELECTION_ADD = "TIMELINE_SELECTION_ADD",
  TIMELINE_SELECTION_CLEAR = "TIMELINE_SELECTION_CLEAR",
  TIMELINE_SELECTION_DIRECTION = "TIMELINE_SELECTION_DIRECTION",
  TIMELINE_SELECTION_RANGE = "TIMELINE_SELECTION_RANGE",
  TIMELINE_SELECTION_SET = "TIMELINE_SELECTION_SET",
  TIMELINE_CLOSE_GAPS_LEFT = "TIMELINE_CLOSE_GAPS_LEFT",
  TIMELINE_CLOSE_GAPS_RIGHT = "TIMELINE_CLOSE_GAPS_RIGHT",
  TIMELINE_OPTIMIZE_OPERATIONS_LEFT = "TIMELINE_OPTIMIZE_OPERATIONS_LEFT",
  TIMELINE_OPTIMIZE_OPERATIONS_RIGHT = "TIMELINE_OPTIMIZE_OPERATIONS_RIGHT",
  TIMELINE_OPERATION_REPLAN = "TIMELINE_OPERATION_REPLAN",
  TIMELINE_OPERATION_CALCULATE_DURATION = "TIMELINE_OPERATION_CALCULATE_DURATION",
  TIMELINE_FILTER_CLEVER = "TIMELINE_FILTER_CLEVER",
  TIMELINE_FILTER_RESET = "TIMELINE_FILTER_RESET",
  TIMELINE_TRIGGER_RAW = "TIMELINE_TRIGGER_RAW",
  TIMELINE_DATA_FETCH_PROJECTS = "TIMELINE_DATA_FETCH_PROJECTS",
  TIMELINE_DATA_FETCH_RESET = "TIMELINE_DATA_FETCH_RESET",
  TIMELINE_UPDATE_PROJECTS = "TIMELINE_UPDATE_PROJECTS",
  TIMELINE_UPDATE_PROJECTS_SAVE_TO_PAST = "TIMELINE_UPDATE_PROJECTS_SAVE_TO_PAST",
  TIMELINE_SET_LOADING = "TIMELINE_SET_LOADING",
  TIMELINE_UNSET_LOADING = "TIMELINE_UNSET_LOADING",
  TIMELINE_PRODUCTIONORDER_LOCKED = "TIMELINE_PRODUCTIONORDER_LOCKED",
  TIMELINE_VERSION_UPDATE = "TIMELINE_VERSION_UPDATE",

  ENTITIES_UPDATE_PERSISTS = "ENTITIES_UPDATE_PERSISTS",
  TIMELINE_ITEM_UNDO_UPDATE = "TIMELINE_ITEM_UNDO_UPDATE",

  FILE_UPLOAD = "FILE_UPLOAD",
  FILE_UPLOAD_REQUEST = "FILE_UPLOAD_REQUEST",
  FILE_UPLOAD_DO_REQUEST = "FILE_UPLOAD_DO_REQUEST",
  FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS",
  FILE_UPLOAD_FAILURE = "FILE_UPLOAD_FAILURE",

  FILE_UPLOAD_CLEAR_FILELIST = "FILE_UPLOAD_CLEAR_FILELIST",
  FILE_UPLOAD_REMOVE_FILE = "FILE_UPLOAD_REMOVE_FILE",

  BASEDATA_RESOURCEGAPS_FORM_DATEFROM_CHANGE = "BASEDATA_RESOURCEGAPS_FORM_DATEFROM_CHANGE",
  USERS_LICENSE_SET_DEFAULT = "USERS_LICENSE_SET_DEFAULT",
  USERS_CHANGE_PASSWORD_RESET = "USERS_CHANGE_PASSWORD_RESET",
  USERS_LANGUAGE_UPDATE = "USERS_LANGUAGE_UPDATE",
  SHOWARCHIVED_TOOGLE = "SHOWARCHIVED_TOOGLE",
  SOCKET_RECEIVED_CONFLICTS_COUNT = "SOCKET_RECEIVED_CONFLICTS_COUNT",
  SOCKET_RECEIVED_PLAN_ON_OPERATION_IDS = "SOCKET_RECEIVED_PLAN_ON_OPERATION_IDS",
  SOCKET_RECEIVED_PLAN_OFF_OPERATION_IDS = "SOCKET_RECEIVED_PLAN_OFF_OPERATION_IDS",
  SEND_WEBSOCKET_MESSAGE = "SEND_WEBSOCKET_MESSAGE",
  USER_DETAILS_SELF_UPDATE = "USER_DETAILS_SELF_UPDATE",
  USER_FORM_ERROR_RESET = "USER_FORM_ERROR_RESET",
  SET_STANDARD_MODE = "SET_STANDARD_MODE",
  SET_TERMINAL_MODE = "SET_TERMINAL_MODE",
  SET_SCREEN_MODE = "SET_SCREEN_MODE",
  SOCKET_RECEIVED_MESSAGE = "SOCKET_RECEIVED_MESSAGE",
}

export default ActionTypes
